// extracted by mini-css-extract-plugin
export var deleteModal = "_ri-0";